import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  useMediaQuery,
  useTheme
} from '@mui/material';
import PDFViewer from '../../PDFViewer';
import DownloadIcon from '@mui/icons-material/Download';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';

export default function ReceiptDetailDialog({ open, onClose, URL, type = 'receipt' }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleDownloadPdf = () => {
        const link = document.createElement('a');
        link.href = URL;
        link.download = (type === 'receipt') ? 'receipt.pdf' : 'invoice.pdf';
        link.click();
    };

    const handlePrintPDF = () => {
        const printWindow = window.open(URL);

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
        };
    }

    const style = {
        action: 'bg-[#fafafa]',
        content: 'overflow-x-auto self-center bg-[#9ca3af]'
    }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      sx={{ fontSize: '1rem' }}
      fullWidth={isMobile}
    >
        <DialogTitle sx={{ fontSize: '1rem' }} className={style.action}>
          {
            (type === 'receipt') ?
              (<span>ใบเสร็จชำระเงิน< ReceiptLongIcon color = 'primary' /> </span> ) :
              (<span>ใบแจ้งหนี้<PictureAsPdfIcon color = 'primary' /> </span>)
          }
        </DialogTitle>
        <DialogContent sx={{ p: 0 }} className={style.content}>
          <PDFViewer pdfUrl={URL} />
        </DialogContent>
        <DialogActions className={style.action}>
          <Button sx={{ gap: '4px' }} onClick={handlePrintPDF}>
            <PrintIcon />
            พิมพ์
          </Button>
          <Button onClick={ handleDownloadPdf }>
            <DownloadIcon/>
            ดาวน์โหลด
          </Button>
          <Button onClick={onClose} color='error'>
            ปิด
          </Button>
        </DialogActions>
    </Dialog>
  )
}

